import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { toast } from "react-toastify";

import { viewSurveyParticipantResponses } from "../../Utils/adminFunctions";

let AdminListResponses = () => {
  const { surveyID } = useParams();
  const [noOfParticipantResponses, setNoOfParticipantResponses] = useState("");
  const [totalParticipants, setTotalParticipants] = useState("");
  const [totalPercentage, setTotalPercentage] = useState("");
  const [remainingParticipants, setRemainingParticipants] = useState("");
  const [listParticipantsResponses, setListParticipantsResponses] =
    useState("");

  useEffect(() => {
    async function fetchAPI1() {
      const response = await viewSurveyParticipantResponses(surveyID);

      if (response.status === "success") {
        setNoOfParticipantResponses(response.data.no_of_responses);
        setTotalParticipants(response.data.no_of_paticipants);
        let tmpPerc =
          (response.data.no_of_responses * 100) /
          response.data.no_of_paticipants;

        setTotalPercentage(tmpPerc + "%");
        setRemainingParticipants(
          response.data.no_of_paticipants - response.data.no_of_responses
        );
        
        setListParticipantsResponses(response.participantList);
      } else {
        toast.error(response, { autoClose: 1500 });
      }
    }

    fetchAPI1();
  }, []);

  return (
    <div>
     
      <div className="wrapper">
        <div>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        <p>Pending Response</p>
                      </div>
                      <div className="col-md-6">
                        <p className="pull-right">
                          No. of participant responses/Total Participants​
                        </p>
                      </div>
                    </div>

                    <div className="progress">
                      <div
                        className="progress-bar bg-primary progress-bar-striped"
                        role="progressbar"
                        aria-valuenow={50}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        style={{ width: totalPercentage }}
                      ></div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        {" "}
                        <p>{remainingParticipants}</p>
                      </div>
                      <div className="col-md-6">
                        <p className="pull-right">
                          {noOfParticipantResponses}/{totalParticipants}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title pull-right ">
                          <Link
                            to={"/AdminSurveyDetails/" + surveyID}
                            className="btn btn-sm custom-btn-primary"
                          >
                            <i className="fa fa-arrow-left"></i> Back
                          </Link>
                        </h3>
                      </div>

                      <div className="card-body">
                        <table
                          id="example1"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>Participant Name</th> 
                              <th>Status</th>
                              {/* <th>Email</th> */}
                            </tr>
                          </thead>

                          <tbody>{listParticipantsResponses}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListResponses;
